/** The keys the grid answers to, in the order the shortcut sheet lists them. One list, so the sheet and
 * the grid are changed in the same diff. */

export const SHORTCUTS: ReadonlyArray<{ keys: string; does: string }> = [
  { keys: "Up / Down", does: "Move between rows" },
  { keys: "Left / Right", does: "Move between cells" },
  { keys: "Home / End", does: "First / last row (in a cell: first / last cell)" },
  { keys: "Page Up / Page Down", does: "Ten rows up / down" },
  { keys: "Enter", does: "Open the row" },
  { keys: "Space", does: "Preview the row" },
  { keys: "Esc", does: "Close the preview, then clear the selection" },
  { keys: "Shift + click", does: "Select a range of rows, or add a sort level" },
  { keys: "Alt + Down", does: "Open a column's menu" },
  { keys: "?", does: "Show this sheet" },
];

